import './dashboardTable.css';

import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { standardDate } from '../../../utils/formatDate';

export default function DashboardTable({ tableData }) {
    const [rowClickId, setRowClickId] = useState(0);
    const tableHeader = ['Name', 'Trip Date', 'Days/Nights', 'Slots', 'Start City', 'Difficulty', 'Status'];
    // const tableHeader = ['Name', 'Location', 'ChechKIn', 'ChecKOut', 'Type', 'Booked','Available','Status'];

    useEffect(() => {
        if (rowClickId !== 0) {
            window.open(`/org/trip/date/${rowClickId}`, '_blank');
            setRowClickId(0);
        }
    }, [rowClickId]);

    const getStartCity = (row) => {
        const city = row?.startCities?.map((item) => {
            return `${item?.city ?? 'N/A'} - ₹${item?.price.total ?? 'N/A'}, `;
        });
        return city;
    };

    return (
        <>
            <div className='table-top-container'>
                <table className='table'>
                    <thead className='tableHead'>
                        <tr>
                            {tableHeader.map((head, headIndex) => {
                                return <th key={headIndex}>{head}</th>;
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData?.map((row, rowIndex) => {
                            return (
                                <tr
                                    key={rowIndex}
                                    className={
                                        row?.tripStatus === 'Cancelled'
                                            ? 'tableBodyCancelledRow'
                                            : 'tableBodyRow allowCLick'
                                    }
                                    onClick={() => setRowClickId(row._id)}
                                >
                                    <td className='ellipsisCell'>{row.name ?? 'N/A'}</td>
                                    <td>{standardDate(row.startDate) ?? 'N/A'}</td>
                                    <td>{`${row.days ?? 'N/A'} days/${row.nights ?? 'N/A'} nights`}</td>
                                    <td>{`${row.bookedSlots ?? 'N/A'}/${row.totalSlots ?? 'N/A'}`}</td>
                                    <td className='ellipsisCell'>{getStartCity(row)}</td>
                                    <td>{row.difficulty ?? 'N/A'}</td>
                                    <td>{row.status ?? 'N/A'}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div className='responsiveCardContainer'>
                    {tableData?.map((row, rowIndex) => (
                        <div key={rowIndex} className='responsiveCard' onClick={() => setRowClickId(row._id)}>
                            <div className='cardContent'>
                                <p>
                                    <strong>{tableHeader[0]}</strong> {row.name ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>{tableHeader[1]}</strong> {standardDate(row.startDate) ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>{tableHeader[2]}</strong>{' '}
                                    {`${row.days ?? 'N/A'} days / ${row.nights ?? 'N/A'} nights`}
                                </p>
                                <p>
                                    <strong>{tableHeader[3]}</strong>{' '}
                                    {`${row.bookedSlots ?? 'N/A'} / ${row.totalSlots ?? 'N/A'}`}
                                </p>
                                <p>
                                    <strong>{tableHeader[4]}</strong> {getStartCity(row)}
                                </p>
                                <p>
                                    <strong>{tableHeader[5]}</strong> {row.difficulty ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>{tableHeader[6]}</strong> {row.status ?? 'N/A'}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
